import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import axios from 'utils/axios';
import URL from 'config/url';
import axiosAdmin from 'utils/axiosAdmin';

export const getHotelRadius = createAsyncThunk('GET HOTEL RADIUS', async (thunkAPI) => {
  const response = await axios.get(URL.HOTEL_RADIUS, thunkAPI);
  return response.data;
});

export const updateHotelRadius = createAsyncThunk('UPDATE HOTEL RADIUS', async (thunkAPI) => {
  const response = await axios.patch(URL.HOTEL_RADIUS, thunkAPI);
  return response.data;
});

export const getHotelVendors = createAsyncThunk('GET HOTEL VENDORS', async (thunkAPI) => {
  const response = await axios.get(URL.HOTEL_VENDORS, thunkAPI);
  return response.data;
});

export const updateHotelVendors = createAsyncThunk('UPDATE HOTEL VENDORS', async (thunkAPI) => {
  const response = await axios.patch(URL.HOTEL_VENDORS, thunkAPI);
  return response.data;
});
export const getCurrentAutoSuggestVendor = createAsyncThunk('GET HOTEL AUTOSUGGEST', async (thunkAPI) => {
  const response = await axios.get(URL.HOTEL_AUTOSUGGEST, thunkAPI);
  return response.data;
});

export const updateCurrentAutoSuggestVendor = createAsyncThunk('UPDATE HOTEL AUTOSUGGEST', async (thunkAPI) => {
  const response = await axios.patch(URL.HOTEL_AUTOSUGGEST, thunkAPI);
  return response.data;
});
export const getPaymentGateways = createAsyncThunk('GET PAYMENT GATEWAYS', async (_, thunkAPI) => {
  const response = await axiosAdmin.get(URL.PAYMENT_GATEWAYS, thunkAPI);
  return response.data;
});

export const updatePaymentGateways = createAsyncThunk('UPDATE PAYMENT GATEWAYS', async (data, thunkAPI) => {
  const response = await axiosAdmin.patch(URL.PAYMENT_GATEWAYS, data, thunkAPI);
  return response.data;
});

export const updateGlobalPaymentGatewayStatus = createAsyncThunk(
  'UPDATE GLOBAL PYAMENT GATEWAY STATUS',
  async (data, thunkAPI) => {
    const response = await axiosAdmin.patch(URL.PAYMENT_GATEWAYS, data, thunkAPI);
    return response.data;
  }
);

export const updateGlobalPayment3dsStatus = createAsyncThunk(
  'UPDATE GLOBAL PYAMENT 3DS STATUS',
  async (data, thunkAPI) => {
    const response = await axiosAdmin.patch(URL.PAYMENT_GATEWAYS, data, thunkAPI);
    return response.data;
  }
);

export const updateDefaultGatewaySignup = createAsyncThunk('UPDATE DEFAULT GATEWAY SIGNUP', async (data, thunkAPI) => {
  const response = await axiosAdmin.patch(URL.DEFAULT_GATEWAY_SIGNUP, data, thunkAPI);
  return response.data;
});

export const updateGlobalHotelVendorStatus = createAsyncThunk('UPDATE GLOBAL HOTEL VENDOR STATUS', async (thunkAPI) => {
  const response = await axios.patch(URL.UPDATE_GLOBAL_HOTEL_VENDOR_STATUS, thunkAPI);
  return response.data;
});

export const getSettingByName = createAsyncThunk('GET OTP ENABLE STATUS', async (data, thunkAPI) => {
  const query=`?setting_type=${data.setting_type}`;
  const response = await axiosAdmin.get(`${URL.GLOBAL_OTP_SIGNUP_STATUS}${query}`, thunkAPI);
  return response.data;
});

export const updateSettingByName = createAsyncThunk('UPDATE OTP ENABLE STATUS', async (data, thunkAPI) => {
  const response = await axiosAdmin.patch(URL.UPDATE_GLOBAL_OTP_SIGNUP_STATUS, data,thunkAPI);
  return response.data;
});

export const getGlobalHideHeaderforDealProposalStatus = createAsyncThunk('GET HIDE HEADER STATUS', async (thunkAPI) => {
  const response = await axios.get(URL.GLOBAL_HIDE_HEADER_STATUS, thunkAPI);
  return response.data;
});

export const updateGlobalHideHeaderforDealProposalStatus = createAsyncThunk(
  'UPDATE HIDE HEADER STATUS',
  async (thunkAPI) => {
    const response = await axios.patch(URL.UPDATE_GLOBAL_HIDE_HEADER_STATUS, thunkAPI);
    return response.data;
  }
);

export const getGlobalExtranetStatus = createAsyncThunk('GET GLOBAL EXTRANET STATUS', async (thunkAPI) => {
  const response = await axiosAdmin.get(URL.GLOBAL_EXTRANET_STATUS, thunkAPI);
  return response.data;
});

export const updateGlobalExtranetStatus = createAsyncThunk('UPDATE GLOBAL EXTRANET STATUS', async (thunkAPI) => {
  const response = await axios.patch(URL.UPDATE_GLOBAL_EXTRANET_STATUS, thunkAPI);
  return response.data;
});

export const getGlobalTripAddEnableStatus = createAsyncThunk('GET TripAdd ENABLE STATUS', async (thunkAPI) => {
  const response = await axios.get(URL.GLOBAL_TRIP_ADD_STATUS, thunkAPI);
  return response.data;
});

export const updateGlobalTripAddEnableStatus = createAsyncThunk('UPDATE TripAdd ENABLE STATUS', async (thunkAPI) => {
  const response = await axios.patch(URL.UPDATE_GLOBAL_TRIP_ADD_STATUS, thunkAPI);
  return response.data;
});

export const getSupplierVendors = createAsyncThunk('GET SUPPLIER VENDORS', async (data, thunkAPI) => {
  const params = new URLSearchParams({ product_type: data.product_type });
  const response = await axiosAdmin.get(`${URL.SUPPLIER_VENDORS}?${params.toString()}`, thunkAPI);
  return { ...response.data, _productType: data.product_type };
});

export const updateSupplierVendor = createAsyncThunk('UPDATE SUPPLIER VENDOR', async (data, thunkAPI) => {
  const response = await axiosAdmin.put(
    URL.SUPPLIER_VENDORS,
    {
      id: data.id,
      status: data.status,
    },
    thunkAPI
  );
  if (response.data?.status === 'success' && data.product_type) {
    thunkAPI.dispatch(getSupplierVendors({ product_type: data.product_type }));
  }
  return { ...response.data, _sentData: data };
});

const initialState = {
  isLoading: false,
  isLoadingDefaultGateway: false,
  isDefaultSignupUpdating: false,
  settingsData: null,
  isSuccess: false,
  settingsDataByName: null,
  hideHeaderData: null,
  tripAddSettingData: null,
  defaultGateway: null,
  supplierVendors: {
    HOTEL: [],
    FLIGHT: [],
  },
  isSupplierVendorsLoading: {
    HOTEL: false,
    FLIGHT: false,
  },
  updatingSupplierVendor: null,
  supplierVendorsRollback: null,
};

export const activitySlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {},
  extraReducers: {
    // get hotel radius
    [getHotelRadius.pending]: (state) => {
      state.isLoading = true;
      state.settingsData = null;
    },
    [getHotelRadius.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.settingsData = action.payload.data;
    },
    [getHotelRadius.rejected]: (state, action) => {
      state.isLoading = false;
      state.settingsData = null;
      toast.error(action?.payload?.message);
    },

    // update hotel radius
    [updateHotelRadius.pending]: (state) => {
      state.isLoading = true;
      state.settingsData = null;
    },
    [updateHotelRadius.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.settingsData = action.payload.data;
    },
    [updateHotelRadius.rejected]: (state, action) => {
      state.isLoading = false;
      state.settingsData = null;
      toast.error(action?.payload?.message);
    },

    //get hotel vendors
    [getHotelVendors.pending]: (state) => {
      state.isLoading = true;
      state.settingsData = null;
    },
    [getHotelVendors.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.settingsData = action.payload.data;
    },
    [getHotelVendors.rejected]: (state, action) => {
      state.isLoading = false;
      state.settingsData = null;
      toast.error(action?.payload?.message);
    },

    //get hotel Autosuggest
    [getCurrentAutoSuggestVendor.pending]: (state) => {
      state.isLoading = true;
      state.settingsData = null;
    },
    [getCurrentAutoSuggestVendor.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.settingsData = action.payload.data;
    },
    [getCurrentAutoSuggestVendor.rejected]: (state, action) => {
      state.isLoading = false;
      state.settingsData = null;
      toast.error(action?.payload?.message);
    },
    //update hotel Autosuggest
    [updateCurrentAutoSuggestVendor.pending]: (state) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.settingsData = null;
    },
    [updateCurrentAutoSuggestVendor.fulfilled]: (state) => {
      state.isLoading = false;
      state.isSuccess = true;
    },
    [updateCurrentAutoSuggestVendor.rejected]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.settingsData = null;
      toast.error(action?.payload?.message);
    },

    //update hotel vendors
    [updateHotelVendors.pending]: (state) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.settingsData = null;
    },
    [updateHotelVendors.fulfilled]: (state) => {
      state.isLoading = false;
      state.isSuccess = true;
    },
    [updateHotelVendors.rejected]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.settingsData = null;
      toast.error(action?.payload?.message);
    },

    //get payment gateways
    [getPaymentGateways.pending]: (state) => {
      state.isLoading = true;
    },
    [getPaymentGateways.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.settingsData = action.payload.data;
    },
    [getPaymentGateways.rejected]: (state, action) => {
      state.isLoading = false;
      state.settingsData = null;
      toast.error(action?.payload?.message);
    },

    //update payment gateways
    [updatePaymentGateways.pending]: (state) => {
      state.isLoading = true;
    },
    [updatePaymentGateways.fulfilled]: (state) => {
      state.isLoading = false;
    },
    [updatePaymentGateways.rejected]: (state, action) => {
      state.isLoading = false;
      toast.error(action?.payload?.message);
    },

    [updateGlobalPaymentGatewayStatus.pending]: (state) => {
      state.isLoading = true;
    },
    [updateGlobalPaymentGatewayStatus.fulfilled]: (state) => {
      state.isLoading = false;
    },
    [updateGlobalPaymentGatewayStatus.rejected]: (state, action) => {
      state.isLoading = false;
      toast.error(action?.payload?.message);
    },

    [updateGlobalPayment3dsStatus.pending]: (state) => {
      state.isLoading = true;
    },
    [updateGlobalPayment3dsStatus.fulfilled]: (state) => {
      state.isLoading = false;
    },
    [updateGlobalPayment3dsStatus.rejected]: (state, action) => {
      state.isLoading = false;
      toast.error(action?.payload?.message);
    },

    [updateDefaultGatewaySignup.pending]: (state) => {
      state.isDefaultSignupUpdating = true;
    },
    [updateDefaultGatewaySignup.fulfilled]: (state) => {
      state.isDefaultSignupUpdating = false;
    },
    [updateDefaultGatewaySignup.rejected]: (state, action) => {
      state.isDefaultSignupUpdating = false;
      toast.error(action?.payload?.message);
    },

    [updateGlobalHotelVendorStatus.pending]: (state) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.settingsData = null;
    },
    [updateGlobalHotelVendorStatus.fulfilled]: (state) => {
      state.isLoading = false;
      state.isSuccess = true;
    },
    [updateGlobalHotelVendorStatus.rejected]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.settingsData = null;
      toast.error(action?.payload?.message);
    },

    [getSettingByName.pending]: (state) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.settingsDataByName = null;
    },
    [getSettingByName.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.settingsDataByName = action.payload.data;
      state.isSuccess = true;
    },
    [getSettingByName.rejected]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.settingsDataByName = null;
      toast.error(action?.payload?.message);
    },

    [updateSettingByName.pending]: (state) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.settingsDataByName = null;
    },
    [updateSettingByName.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.settingsDataByName = action.payload.data;
      state.isSuccess = true;
    },
    [updateSettingByName.rejected]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.settingsDataByName = null;
      toast.error(action?.payload?.message);
    },

    [getGlobalHideHeaderforDealProposalStatus.pending]: (state) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.hideHeaderData = null;
    },
    [getGlobalHideHeaderforDealProposalStatus.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.hideHeaderData = action.payload.data;
      state.isSuccess = true;
    },
    [getGlobalHideHeaderforDealProposalStatus.rejected]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.hideHeaderData = null;
      toast.error(action?.payload?.message);
    },

    [updateGlobalHideHeaderforDealProposalStatus.pending]: (state) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.hideHeaderData = null;
    },
    [updateGlobalHideHeaderforDealProposalStatus.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.hideHeaderData = action.payload.data;
      state.isSuccess = true;
    },
    [updateGlobalHideHeaderforDealProposalStatus.rejected]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.hideHeaderData = null;
      toast.error(action?.payload?.message);
    },

    [getGlobalExtranetStatus.pending]: (state) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.extranetEnabledData = null;
    },
    [getGlobalExtranetStatus.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.extranetEnabledData = action.payload.data;
      state.isSuccess = true;
    },
    [getGlobalExtranetStatus.rejected]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.extranetEnabledData = null;
      toast.error(action?.payload?.message);
    },

    [updateGlobalExtranetStatus.pending]: (state) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.extranetEnabledData = null;
    },
    [updateGlobalExtranetStatus.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.extranetEnabledData = action.payload.data;
      state.isSuccess = true;
    },
    [updateGlobalExtranetStatus.rejected]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.extranetEnabledData = null;
      toast.error(action?.payload?.message);
    },

    [getGlobalTripAddEnableStatus.pending]: (state) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.tripAddSettingData = null;
    },
    [getGlobalTripAddEnableStatus.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.tripAddSettingData = action.payload.data;
      state.isSuccess = true;
    },
    [getGlobalTripAddEnableStatus.rejected]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.tripAddSettingData = null;
      toast.error(action?.payload?.message);
    },

    [updateGlobalTripAddEnableStatus.pending]: (state) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.tripAddSettingData = null;
    },
    [updateGlobalTripAddEnableStatus.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.tripAddSettingData = action.payload.data;
      state.isSuccess = true;
    },
    [updateGlobalTripAddEnableStatus.rejected]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.tripAddSettingData = null;
      toast.error(action?.payload?.message);
    },

    [getSupplierVendors.pending]: (state, action) => {
      const productType = action.meta?.arg?.product_type;
      if (productType) state.isSupplierVendorsLoading[productType] = true;
    },
    [getSupplierVendors.fulfilled]: (state, action) => {
      const productType = action.payload._productType;
      if (productType) {
        state.isSupplierVendorsLoading[productType] = false;
        state.supplierVendors[productType] = action.payload.data || [];
      }
    },
    [getSupplierVendors.rejected]: (state, action) => {
      const productType = action.meta?.arg?.product_type;
      if (productType) state.isSupplierVendorsLoading[productType] = false;
      toast.error(action?.payload?.message || 'Failed to load supplier vendors');
    },

    [updateSupplierVendor.pending]: (state, action) => {
      const { id, status, product_type } = action.meta?.arg || {};
      state.updatingSupplierVendor = { id, product_type };
      const vendors = state.supplierVendors[product_type] || [];
      state.supplierVendorsRollback = {
        product_type,
        vendors: vendors.map((v) => ({ ...v })),
      };
      state.supplierVendors[product_type] = vendors.map((v) =>
        v.id === id ? { ...v, status } : v
      );
    },
    [updateSupplierVendor.fulfilled]: (state, action) => {
      state.updatingSupplierVendor = null;
      state.supplierVendorsRollback = null;
      toast.success(action?.payload?.message || 'Vendor updated successfully');
    },
    [updateSupplierVendor.rejected]: (state, action) => {
      const rollback = state.supplierVendorsRollback;
      if (rollback?.product_type) {
        state.supplierVendors[rollback.product_type] = rollback.vendors;
      }
      state.updatingSupplierVendor = null;
      state.supplierVendorsRollback = null;
      toast.error(action?.payload?.message || 'Failed to update supplier vendor');
    },
  },
});

export default activitySlice.reducer;
